import { Component } from '@angular/core';
interface Image {
  src: string;
  thumbnail: string;
  alt: string;
}
@Component({
  selector: 'app-events-paiting',
  templateUrl: './events-paiting.component.html',
  styleUrls: ['./events-paiting.component.scss'],
})
export class EventsPaitingComponent {
  images: Image[] = [
    {
      src: 'assets/img/school/events/painting/1.jpg',
      thumbnail: 'assets/img/school/events/painting/1.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/painting/2.jpg',
      thumbnail: 'assets/img/school/events/painting/2.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/painting/3.jpg',
      thumbnail: 'assets/img/school/events/painting/3.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/painting/4.jpg',
      thumbnail: 'assets/img/school/events/painting/4.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/painting/5.jpg',
      thumbnail: 'assets/img/school/events/painting/5.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/painting/6.jpg',
      thumbnail: 'assets/img/school/events/painting/6.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/painting/7.jpg',
      thumbnail: 'assets/img/school/events/painting/7.jpg',
      alt: 'Image 01',
    },
    {
      src: 'assets/img/school/events/painting/8.jpg',
      thumbnail: 'assets/img/school/events/painting/8.jpg',
      alt: 'Image 01',
    },
  ];
}
